import { render } from "./SelectItem.vue?vue&type=template&id=65ce15d2"
import script from "./SelectItem.vue?vue&type=script&lang=js"
export * from "./SelectItem.vue?vue&type=script&lang=js"

import "./SelectItem.vue?vue&type=style&index=0&id=65ce15d2&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__